export enum CustomizerMenuType {
  Captions = 'Captions',
  Templates = 'Templates',
  Layout = 'Layout',
  Background = 'Background',
  Speakers = 'Speakers',
  Translation = 'Translation',
  Images = 'Images',
  AI = 'AI',
  PromptOverride = 'PromptOverride',
  Videos = 'Videos',
  Audio = 'Audio',
  Overlays = 'Overlays'
}

export enum TemplatesPopupTabs {
  Preset = 'Preset',
  MyTemplates = 'My Templates'
}

export const TEMPLATES_POPUP_TABS: { name: TemplatesPopupTabs; showDefaultOnly?: boolean }[] = [
  {
    name: TemplatesPopupTabs.Preset,
    showDefaultOnly: true
  },
  {
    name: TemplatesPopupTabs.MyTemplates,
    showDefaultOnly: false
  }
];
